import { createServiceClient } from "shared/welda/services/axiosClient";

const apiMMS = createServiceClient("/mms");

const SearchProducts = async (searchParams) => {
  const response = await apiMMS.post("/SearchProducts", searchParams);
  return response;
};

const getRecommendedProducts = async (params) => {
  const response = await apiMMS.get("/getRecommendedProducts", {
    params,
  });
  return response;
};

const getCategories = async (params) => {
  const response = await apiMMS.get("/getCategories", {
    params,
  });
  return response;
};

const addProductLink = async (data) => {
  const response = await apiMMS.post("/add-product-link", data);
  return response;
};

const analyzeProductLinkImport = async (data) => {
  const response = await apiMMS.post("/analyze-product-link-import", { data });
  return response;
};

const getSupplierDocDefaultPrompt = async () => {
  const response = await apiMMS.get("/supplier-doc-import/default-prompt");
  return response;
};

const analyzeSupplierDocImport = async (data) => {
  const response = await apiMMS.post("/analyze-supplier-doc-import", data, {
    timeout: 10 * 60 * 1000,
  });
  return response;
};

const analyzeSupplierJsonImport = async (data) => {
  const response = await apiMMS.post("/analyze-supplier-json-import", data, {
    timeout: 10 * 60 * 1000,
  });
  return response;
};

const importSupplierDocImport = async (data) => {
  const response = await apiMMS.post("/import-supplier-doc-import", data);
  return response;
};

const getProductLinks = async (params = {}) => {
  const response = await apiMMS.get("/product-links", { params });
  return response;
};

const getPriceAnomalies = async (params = {}) => {
  const response = await apiMMS.get("/price-anomalies", {
    params,
    timeout: 120000,
  });
  return response;
};

const getPriceDifferences = async (params = {}) => {
  const response = await apiMMS.get("/price-differences", {
    params,
    timeout: 120000,
  });
  return response;
};

const getRodePrijslijst = async (params = {}) => {
  const response = await apiMMS.get("/rode-prijslijst", {
    params,
    timeout: 120000,
  });
  return response;
};

/** All MMS products (lean: Nummer, Naam, dossier, leverancier, rekeningen). */
const getAllProducts = async (params = {}) => {
  const response = await apiMMS.get("/products", {
    params,
    timeout: 180000,
  });
  return response;
};

const getArticlePriceHistory = async (nummer, params = {}) => {
  const response = await apiMMS.get(
    `/products/${encodeURIComponent(nummer)}/price-history`,
    {
      params,
      timeout: 120000,
    },
  );
  return response;
};

const updateProductLink = async (id, data) => {
  const response = await apiMMS.patch(
    `/product-links/${encodeURIComponent(id)}`,
    data
  );
  return response;
};

const deleteProductLink = async (id) => {
  const response = await apiMMS.delete(
    `/product-links/${encodeURIComponent(id)}`
  );
  return response;
};

const deleteProductLinks = async (ids) => {
  const response = await apiMMS.post("/product-links/bulk-delete", { ids });
  return response;
};

const listSupplierDocImports = async (params) => {
  const response = await apiMMS.get("/supplier-doc-imports", { params });
  return response;
};

const getSupplierDocImport = async (id) => {
  const response = await apiMMS.get(
    `/supplier-doc-imports/${encodeURIComponent(id)}`
  );
  return response;
};

const updateSupplierDocImport = async (id, data) => {
  const response = await apiMMS.patch(
    `/supplier-doc-imports/${encodeURIComponent(id)}`,
    data
  );
  return response;
};

const deleteSupplierDocImport = async (id) => {
  const response = await apiMMS.delete(
    `/supplier-doc-imports/${encodeURIComponent(id)}`
  );
  return response;
};

const deleteSupplierDocImports = async (ids) => {
  const response = await apiMMS.post("/supplier-doc-imports/bulk-delete", {
    ids,
  });
  return response;
};

const listRentalConfigurations = async (params = {}) => {
  const response = await apiMMS.get("/rental-configurations", { params });
  return response;
};

const getRentalConfiguration = async (id) => {
  const response = await apiMMS.get(
    `/rental-configurations/${encodeURIComponent(id)}`,
  );
  return response;
};

const createRentalConfiguration = async (data) => {
  const response = await apiMMS.post("/rental-configurations", data);
  return response;
};

const updateRentalConfiguration = async (id, data) => {
  const response = await apiMMS.put(
    `/rental-configurations/${encodeURIComponent(id)}`,
    data,
  );
  return response;
};

const deleteRentalConfiguration = async (id) => {
  const response = await apiMMS.delete(
    `/rental-configurations/${encodeURIComponent(id)}`,
  );
  return response;
};

const getProductgroepen = async () => {
  const response = await apiMMS.get("/getProductgroepen");
  return response;
};

const updateProductDescriptions = async (nummer, data) => {
  const response = await apiMMS.put(
    `/products/${encodeURIComponent(nummer)}/descriptions`,
    data,
    { timeout: 120000 },
  );
  return response;
};

const MMSService = {
  SearchProducts,
  getCategories,
  addProductLink,
  analyzeProductLinkImport,
  getSupplierDocDefaultPrompt,
  analyzeSupplierDocImport,
  analyzeSupplierJsonImport,
  importSupplierDocImport,
  getProductLinks,
  getPriceAnomalies,
  getPriceDifferences,
  getRodePrijslijst,
  getAllProducts,
  getArticlePriceHistory,
  updateProductDescriptions,
  updateProductLink,
  deleteProductLink,
  deleteProductLinks,
  listSupplierDocImports,
  getSupplierDocImport,
  updateSupplierDocImport,
  deleteSupplierDocImport,
  deleteSupplierDocImports,
  listRentalConfigurations,
  getRentalConfiguration,
  createRentalConfiguration,
  updateRentalConfiguration,
  deleteRentalConfiguration,
  getProductgroepen,
  getRecommendedProducts,
};

export default MMSService;
